import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ComponentTitle from './ComponentTitle';
import { ProjectConsumer } from './providers/ProjectProvider';

class ComponentBody extends Component {

  render() {

    const { title, onToggleView, appBar, maxWidth, id } = this.props;

    return (
      <ProjectConsumer>
        {({ defaultLang }) => (
          <React.Fragment>
            <ComponentTitle defaultDirection={false} title={title} id={id} defaultLang={defaultLang} onClick={onToggleView} />
            <div style={{ marginTop: '-2px', minWidth: '820px', paddingBottom: '20px' }}>
              {appBar}
              <div style={{
                clear: 'both',
                backgroundColor: 'white',
                padding: '6px',
                borderRadius: 4,
                marginRight: '30px',
                maxWidth,
                minWidth: '800px',
                minHeight: 'calc(100% - 150px)'
              }}>
                {this.props.children}
              </div>
            </div>
          </React.Fragment>
        )}
      </ProjectConsumer>
    );
  }

}

ComponentBody.propTypes = {
  onToggleView: PropTypes.func.isRequired,
  appBar: PropTypes.object.isRequired,
  id: PropTypes.string,
  maxWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.object,
  children: PropTypes.any
};

export default withRouter(ComponentBody);